import * as actionTypes from '../actionTypes/productCarousel';

export function getProductCarouselData(categoryId, count) {
  return { type: actionTypes.PRODUCTCAROUSEL_DATA_LOAD, categoryId, count };
}
